import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { Routes } from '@/router';
import { AnalyticsEventCategory, AnalyticsEventAction, AnalyticsEventLabel } from '@/services/google/google-analytics.services';

@Component({
    name: 'CmgChipotleUAccountModalRewardsStore'
})

export default class CmgChipotleUAccountModalRewardsStore extends Vue {
    mounted() {
        this.$services.reward.getRewardOffers();
        this.$services.reward.getExtrasCampaigns();
        this.$services.featureFlags.refreshApimFeatureFlags();
    }

    get guacModeSmallImageUrl(): string {
        return this.$appStore.state.cms.images.icons.guacModeSmall.default;
    }

    get userIsGuacMode(): boolean {
        return this.$appStore.getters.isCustomerGuacMode;
    }

    get tapeImage(): string {
        return this.$appStore.state.cms.images.loyalty.tape.default;
    }

    get isMobile(): boolean {
        return this.$services.ui.isMobile();
    }

    close() {
        this.$services.ui.setModalVisibility('account', false);
        this.$services.ui.focusBack();
    }

    onClickScanReminder() {
        this.$services.googleAnalytics.sendCustomEvent({
            category: AnalyticsEventCategory.RewardsAccount,
            action: AnalyticsEventAction.ForgotToScanClick,
            label: AnalyticsEventLabel.AccountMenuForgotToScanClick,
        });
        this.$router.push({ name: Routes.RetroCredit });
        this.close();
    }

    onClickViewPointsHistory() {
        this.$router.push({ name: Routes.RewardsPointsHistory });
        this.close();
    }

    onClickGuacMode(){
        this.$services.googleAnalytics.sendCustomEvent({
        category: AnalyticsEventCategory.RewardsAccount,
        action: AnalyticsEventAction.GuacModeClick,
        label: AnalyticsEventLabel.GuacModeClick,
        });
    }

}